<template>
  <div class="row push">
    <div class="col">
      <div class="block">
        <div class="block-header block-header-default">
          <h3 class="block-title">Link toevoegen</h3>
        </div>
        <div class="block-content">
          <div class="form-group">
            <bs-select
              label="Startpagina"
              name="site_id"
              classname="js-select2"
              :options="
                $_.sortBy(
                  sites.map((site) => {
                    return {
                      name: $options.filters.capitalize(site.name),
                      value: site.id,
                    };
                  }),
                  (s) => s.name
                )
              "
              v-model="site_id"
            ></bs-select>
          </div>
          <div class="form-group">
            <bs-select
              label="Pagina"
              name="page_id"
              classname="js-select2"
              :options="
                pages.map((item) => {
                  return {
                    value: item.id,
                    name: $options.filters.capitalize(item.title),
                  };
                })
              "
              :disabled="(!site_id && !pages.length) || pages.length === 0"
              v-model="page_id"
              :addon="price"
              addonTooltip="Indien u gebruikerskorting heeft, wordt deze in de winkelwagen berekend"
            ></bs-select>
          </div>
          <div class="form-group">
            <bs-select
              label="Categorie"
              name="category_id"
              classname="js-select2"
              :options="
                categories.map((item) => {
                  return {
                    value: item.id,
                    name: $options.filters.capitalize(item.title),
                  };
                })
              "
              :disabled="(!page_id && !categories.length) || categories.length === 0"
              v-model="category_id"
            ></bs-select>
          </div>
          <div class="form-group">
            <bs-input
              label="Linktekst"
              name="title"
              classname="js-maxlength"
              maxlength="42"
              :maxlengthShow="true"
              v-model="title"
              helper="Geen www. toegestaan in de linktekst"
            ></bs-input>
          </div>
          <div class="form-group">
            <bs-input label="Url" name="url" v-model="url" helper="Geen Adult links toegestaan"></bs-input>
          </div>
          <div class="form-group">
            <bs-textarea
              label="Linkbeschrijving"
              rows="3"
              classname="js-maxlength"
              maxlength="150"
              :maxlengthShow="true"
              placeholder="Voer hier een beschrijving voor de link in"
              name="description"
              v-model="description"
            ></bs-textarea>
          </div>
          <div class="form-group">
            <bs-radio
              label="Type"
              :inline="true"
              name="follow"
              v-model="follow"
              :options="[
                { name: 'Do follow', value: 1 },
                { name: 'No follow', value: 0 },
              ]"
            ></bs-radio>
          </div>
          <div class="form-group">
            <bs-input
              label="Activeer link per"
              name="start_date"
              classname="js-flatpickr flatpickr-input bg-white"
              :minDate="moment().format('YYYY-MM-DD')"
              v-model="start_date"
            ></bs-input>
          </div>
          <div class="form-group">
            <bs-select label="Periode" name="period" classname="js-select2" :options="periodOptions" v-model="period"></bs-select>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-primary" v-on:click.prevent="submit">Toevoegen</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import EventBus from '../plugins/vue-event-bus';

export default {
  props: ['sites'],
  data: () => {
    return {
      pages: [],
      categories: [],
      errors: [],
      // Link
      site_id: null,
      page_id: null,
      category_id: null,
      title: '',
      url: '',
      description: '',
      follow: 1,
      start_date: moment().format('YYYY-MM-DD'),
      period: null,
    };
  },
  created: function() {
    const urlParams = new URLSearchParams(window.location.search);
    this.site_id = urlParams.get('site_id');
  },
  computed: {
    price: function() {
      var price = null;
      if (this.site_id && this.page_id) {
        var site = this.sites.find((site) => {
          return site.id == this.site_id;
        });

        if (this.page_id == 1) {
          price = site.home_price_discount ? site.home_price_discount : site.home_price;
        } else {
          price = site.daughter_price_discount ? site.daughter_price_discount : site.daughter_price;
          price = price * 4;
        }
      }

      return price ? this.$options.filters.currency(price) : price;
    },
    periodOptions: function() {
      if (this.page_id && this.page_id != 1) {
        return [
          {
            value: 1,
            name: `1 Jaar`,
          },
          {
            value: 2,
            name: `2 Jaar`,
          },
          {
            value: 3,
            name: `3 Jaar`,
          },
          {
            value: 200,
            name: `Permanent`,
          },
        ];
      }

      return Array(10)
        .fill()
        .map((_, idx) => {
          const value = idx + 1;

          return {
            value: value,
            name: `${value} Jaar`,
          };
        });
    },
  },
  watch: {
    site_id: function() {
      var self = this;
      this.pages = [];
      this.categories = [];
      if (this.site_id) {
        axios.get(route('sites.pages.index', this.site_id)).then((response) => {
          if (response.status == 200 && response.data) {
            if (response.data.success) {
              this.page_id = null;
              this.pages = response.data.data;
            }
          }
        });
      }
    },
    page_id: function(newVal, oldVal) {
      var self = this;
      this.categories = [];
      if (this.site_id && this.page_id) {
        this.category_id = null;
        this.categories = this.pages.find((page) => page.id == this.page_id).categories;
      }

      if (newVal && ((oldVal == 1 && newVal != 1) || (oldVal != 1 && newVal == 1) || (oldVal == null && newVal != null))) {
        this.period = newVal == 1 ? 1 : 200;
      }
    },
  },
  methods: {
    submit: function() {
      var self = this;
      axios
        .post(route('cart.update'), {
          site_id: this.site_id,
          link_id: null,
          page_id: this.page_id,
          category_id: this.category_id,
          title: this.title,
          url: this.url,
          description: this.description,
          follow: this.follow,
          start_date: this.start_date,
          period: this.period,
        })
        .then((response) => {
          if (response.status == 200 && response.data) {
            this.errors = response.data.errors;
            if (response.data.success) {
              this.reset();
              EventBus.publish('cart.refresh');
              this.$notify({
                group: 'main',
                type: 'success',
                title: 'De link is toegevoegd en staat in de winkelwagen klaar voor betaling',
              });
            }
          }
        });
    },
    reset: function() {
      Object.keys(this.$options.data()).forEach((key) => {
        this[key] = this.$options.data()[key];
      });
    },
  },
};
</script>
